import { useLocalStorage } from 'react-use';
import { useLogger } from '../logging';
export const NEXT_LOCATION_KEY = 'NEXT_ACTION';
export function useNextLocation() {
    const [data, setData] = useLocalStorage(NEXT_LOCATION_KEY);
    return [data, setData];
}
export function useClearNextLocation() {
    const [log] = useLogger();
    const [_, setData] = useLocalStorage(NEXT_LOCATION_KEY);
    function clearData() {
        log(`Clearing NextLocation`);
        setData('');
    }
    return clearData;
}
export function useSetNextLocation() {
    const [, setData] = useLocalStorage(NEXT_LOCATION_KEY);
    return setData;
}
